// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","245":"notfound","443":"about","631":"contact"}[chunkId] + "." + {"176":"843f0ea2","245":"a577e7ce","443":"e2ff441b","631":"c345028a"}[chunkId] + ".js";
};